import { DoctoralStudyTypeLabels } from "utils/choices";

export const studyTypeLabel = studyTypeId => DoctoralStudyTypeLabels[studyTypeId] ?? "";

const instructionLanguageLabels = {
  1: "Български",
  2: "Английски",
};

export const instructionLanguageLabel = instructionLanguageId =>
  instructionLanguageLabels[instructionLanguageId] ?? "";

export const doctoralSeatLabel = seat => {
  if (!seat) return "";
  return [
    seat.doctoralProgramNameBg,
    studyTypeLabel(seat.studyTypeId),
    instructionLanguageLabel(seat.instructionLanguageId),
  ]
    .filter(Boolean)
    .join(" - ");
};
